<script setup lang="ts">
import { useAuth0 } from '@auth0/auth0-vue'

import { clearFilters } from '@/composables'
import { PROFILE_PATH } from '@/constants'
import { UserInfo } from '@/shared'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
  Icon,
  SidebarMenuButton,
} from '@/ui'

const { logout, user } = useAuth0()

const onLogout = () => {
  logout({
    logoutParams: {
      returnTo: window.location.origin,
    },
  }).then(() => clearFilters(user.value?.sub))
}
</script>

<template>
  <DropdownMenu>
    <DropdownMenuTrigger as-child>
      <SidebarMenuButton
        size="lg"
        class="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
      >
        <UserInfo :user="user" class-name="bg-foreground h-8 w-8 rounded-lg" />
        <Icon name="ChevronUpDownIcon" class="size-4" />
      </SidebarMenuButton>
    </DropdownMenuTrigger>
    <DropdownMenuContent class="w-max min-w-52" align="start">
      <DropdownMenuLabel class="flex font-normal">
        <div class="flex flex-col space-y-1">
          <p class="text-sm leading-none font-medium">{{ user ? user.name : 'Noname' }}</p>
          <p v-if="user" class="text-muted-foreground text-xs leading-none">{{ user.email }}</p>
        </div>
      </DropdownMenuLabel>
      <DropdownMenuSeparator />
      <DropdownMenuGroup>
        <DropdownMenuItem>
          <RouterLink :to="PROFILE_PATH" class="w-full">Profile</RouterLink>
        </DropdownMenuItem>
      </DropdownMenuGroup>
      <DropdownMenuSeparator />
      <DropdownMenuItem @click="onLogout">Log out</DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
</template>
